import React from "react";

import { ReactComponent as DashboardMenuItemIcon } from "../assets/svg/icon-nav-dashboards.svg";
import { ReactComponent as ReportingMenuItemIcon } from "../assets/svg/icon-nav-reports.svg";

export const MENU_ICONS = Object.freeze({
  dashboard: <DashboardMenuItemIcon />,
  reports: <ReportingMenuItemIcon />
});
